// Inbox: the work queue of documents that arrived by email, plus the detail
// drawer and its Flixpector hand-off.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const inbox: Record<string, string> = {
  'Sync mailbox': 'Postfach synchronisieren',
  'Mail ingestion not configured': 'Mail-Eingang nicht konfiguriert',
  'last loaded': 'zuletzt geladen',

  // Item states (types/inbox.ts) — these are also the tab labels
  'With Flixpector': 'Bei Flixpector',
  'Back from Flixpector': 'Zurück von Flixpector',
  'In the database': 'In der Datenbank',
  'Filed without a document': 'Ohne Beleg abgelegt',

  // Document kinds
  'Document kind': 'Belegart',
  'All document kinds': 'Alle Belegarten',
  'Service record': 'Leistungsnachweis',
  'Mail without a document': 'Mail ohne Beleg',

  // Filter bar
  'Supplier, subject, invoice number, file …': 'Lieferant, Betreff, Rechnungsnummer, Datei …',
  Sorting: 'Sortierung',
  'Newest first': 'Neueste zuerst',
  'Highest amount': 'Höchster Betrag',
  'Flagged first': 'Auffälligkeiten zuerst',
  '{n} of {total} entries': '{n} von {total} Einträgen',

  // List
  '(no subject)': '(ohne Betreff)',
  'No attachment': 'Kein Anhang',
  Risk: 'Risiko',
  'Flixpector has no risk score yet': 'Flixpector hat noch keinen Risiko-Score',
  'Flixpector risk score {score} out of 10 — higher means more risk':
    'Flixpector-Risiko-Score {score} von 10 — höher heißt mehr Risiko',
  'Show the original document': 'Originalbeleg anzeigen',
  'No entries': 'Keine Einträge',
  'Nothing in the inbox matches this filter right now.':
    'Für diesen Filter liegt gerade nichts in der Inbox.',
  'This mail has no attachment — see the content in the detail view.':
    'Diese Mail hat keinen Anhang — Inhalt im Detail ansehen.',

  // Action notices
  'Entry deleted.': 'Eintrag gelöscht.',
  'Document kind changed.': 'Belegart geändert.',
  'Marked as done.': 'Als erledigt markiert.',
  'Handed over to Flixpector for review.': 'An Flixpector zur Prüfung übergeben.',
  'Added to the database.': 'In die Datenbank übernommen.',
  'Result fetched from Flixpector.': 'Ergebnis von Flixpector geholt.',
  'Result fetched — the entry is open in the inbox again.':
    'Ergebnis geholt — Eintrag liegt wieder offen in der Inbox.',

  // Detail drawer
  'File without a document': 'Ohne Beleg ablegen',
  'Take off the list — stays stored as a record':
    'Aus der Liste nehmen — bleibt als Nachweis gespeichert',
  'Send to Flixpector': 'An Flixpector prüfen',
  'Fetch result and return to the inbox': 'Ergebnis holen und zurück in die Inbox',
  From: 'Von',
  Received: 'Eingang',
  'High confidence': 'Erkennung sicher',
  'Medium confidence': 'Erkennung mittel',
  'Low confidence': 'Erkennung unsicher',
  'No extraction': 'Keine Extraktion',
  'Choose a handler …': 'Bearbeiter wählen …',
  'Required for the hand-over — travels to Flixpector and is shown there as initials on every line.':
    'Pflicht für die Übergabe — wird an Flixpector übergeben und dort pro Zeile als Kürzel angezeigt.',

  // Flixpector result block
  'Flixpector ID': 'Flixpector-ID',
  'No result yet': 'Noch kein Ergebnis',
  'Review open': 'Prüfung offen',
  'In clarification with the law firm': 'In Abstimmung mit Kanzlei',
  Rejected: 'Abgelehnt',
  Completed: 'Abgeschlossen',
  Agreed: 'Abgestimmt',
  Savings: 'Ersparnis',
  'Fetch result': 'Ergebnis holen',
  'Reviewed in Flixpector by:': 'Geprüft in Flixpector von:',
  'Last fetched:': 'Zuletzt geholt:',

  // Original-document preview
  'Original document': 'Originalbeleg',
  'No attachment — content of the mail': 'Kein Anhang — Inhalt der Mail',
  'No text available.': 'Kein Text vorhanden.',
  'In a new tab': 'In neuem Tab',
  Sheet: 'Blatt',
  'first {n} of {total} rows': 'erste {n} von {total} Zeilen',
  'No preview for this file type — please download it.':
    'Für diesen Dateityp gibt es keine Vorschau — bitte herunterladen.',
  'Preview failed': 'Vorschau fehlgeschlagen',
}
